export default { sha: '2604a89e48de7426a4bb48d87e34dfd0091a1ca1', buildNumber: 'undefined' }
